module.exports = __webpack_public_path__ + "img/login-img.48a6838d.png";